import ExclamationCircle from '../../src/legacy/ExclamationCircle';
export default ExclamationCircle;
